import { useAchievements } from "api/achievements";
import { useAppSelector } from "app/hooks";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { useLocation } from "react-router-dom";
import { selectDefaultLanguageData } from "reduxState/translations/translationsSlice";
import { AchievementBEFormat, BEAchievementRule } from "types/achievements";
import { links } from "utilities/links";
import { markTranslationAsDuplicate } from "../helpers";
import { AchievementForm } from "./AchievementForm";

export function AddAchievement() {
  const { message } = useMessage();
  const { state } = useLocation();
  const { useAchievementData } = useAchievements();
  const { data: achievementData } = useAchievementData(
    state?.duplicateAchievementId,
  );
  const defaultLang = useAppSelector(selectDefaultLanguageData);

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "achievements" }),
      path: links.achievementsList,
    },
  };

  const initialValues: AchievementBEFormat | undefined = achievementData
    ? {
        active: achievementData?.active,
        activity: achievementData?.activity,
        limit: achievementData?.limit,
        rules: achievementData?.rules,
        translations: markTranslationAsDuplicate(
          achievementData.translations,
          message,
        ),
      }
    : state?.template
      ? {
          active: state?.template.active,
          activity: state?.template.activity,
          limit: state?.template.limit,
          rules: state?.template.rules.map((rule: BEAchievementRule) => ({
            ...rule,
            translations: {
              [defaultLang.code]: {
                name: message({
                  id: rule.translations?.[defaultLang.code]?.name,
                }),
                description: message({
                  id: rule.translations?.[defaultLang.code]?.description,
                }),
              },
            },
          })),
          translations: {
            [defaultLang.code]: {
              name: message({
                id: state?.template?.translations?.[defaultLang.code]?.name,
              }),
              description: message({
                id: state?.template.translations?.[defaultLang.code]
                  ?.description,
              }),
            },
          },
        }
      : undefined;

  const isDuplicationMode = state?.duplicateAchievementId;
  const isLoading = isDuplicationMode && !achievementData;

  return (
    <>
      <TopHeader
        title={message({ id: "addAchievement" })}
        clearLink={links.achievementsList}
        breadcrumbs={breadcrumbs}
      />
      {!isLoading && <AchievementForm initialValues={initialValues} />}
    </>
  );
}
